import _ from "lodash";
import moment from "moment-timezone";
import { getDataFromLocalStorage, getDataFromLocalStorageParsed, getEncodedURI, getSideNavMenusURL } from "./util";
import { USER_PREFERENCES } from "../constants/Constants";
import { USER_TIMEZONE } from "../actions/types";
import { fetchIsPrivateOu } from "../actions/Users/authenticate";

export const performPostLoginRedirect = ({ dispatch, history, authReducer }) => {
  let queryString = window.location.search;
  let redirectURL;
  const onlyStarlinkUser = getDataFromLocalStorageParsed("loggedInUser")?.data?.user?.starlinkOnlyUser;
  if (queryString && queryString.includes("?redirectURL=")) {
    redirectURL = queryString.substring(queryString.indexOf("=") + 1);
  }

  let userPreferences = authReducer.loginUser?.data?.user?.preferences;
  let timezone = moment.tz.guess(true) + " - " + moment.tz(moment.tz.guess(true)).format("z");
  if (userPreferences && userPreferences?.timezone) {
    timezone = userPreferences.timezone;
  }
  dispatch({ type: USER_TIMEZONE, payload: timezone });

  let params = onlyStarlinkUser
    ? {
        selectedAccount: "All",
        serviceLineAccess: "All",
        timezone: timezone,
        sideNav: true,
        interval: "MTD",
        startDate: moment(Date.now()).utc().startOf("month").valueOf(),
        endDate: moment(Date.now()).utc().valueOf(),
      }
    : {
        filterApplied: "true",
        internetStatus: "Online,Offline",
        timezone: timezone,
        sideNav: true,
      };

  let dashboardURLPath = "/fleet-dashboard/sites";
  let url_params = `k4Ids=K4-0620%3AMY-FirstVessel&`;

  if (authReducer.dpWiseSideMenu && authReducer.dpWiseSideMenu.length > 0) {
    const menuPathMap = {
      "Hub": "/hub",
      "Account Management": "/account-management/accounts",
      "Inventory": "/inventory",
      "Sites": "/fleet-dashboard/sites",
      "Trends": "/fleet-dashboard/newsummary/sites",
      "Threats": "/threats",
      "Map": "/vessel-map",
      "Reports": "/reports/generatedReports",
      "Alerts": "/alerts/alerts",
      "Tickets": "/tickets",
      "S/W Configuration": "/softwareList",
      "Audit Logs": "/audit-logs",
      "Quota Management": "/quotamanagement",
      "Starlink": "/starlink/starlinkMap",
      "Content Filter": "/contentfilter",
    };

    const firstMenuItem = authReducer.dpWiseSideMenu[0];
    if (menuPathMap[firstMenuItem]) {
      dashboardURLPath = menuPathMap[firstMenuItem];
    }
  } else {
    let new_url = getSideNavMenusURL(dispatch);
    if (new_url) {
      dashboardURLPath = new_url.dashboardURLPath;
      url_params = new_url.url_params;
    }
  }

  try {
    let storedPreferences = JSON.parse(getDataFromLocalStorage(USER_PREFERENCES));
    if (!_.isEmpty(storedPreferences) && storedPreferences?.defaultDashboard && "Trends" == storedPreferences.defaultDashboard) {
      dashboardURLPath = "/fleet-dashboard/newsummary/sites";
    }
  } catch (error) {
  }

  if (redirectURL) {
    let qString;
    if (redirectURL.indexOf("?") > -1) {
      qString = redirectURL.substring(redirectURL.indexOf("?") + 1);
    }
    redirectURL = new URL(redirectURL).pathname;
    if (redirectURL) {
      if (qString) {
        redirectURL = redirectURL + "?" + qString;
      }
      history.replace(redirectURL);
    } else {
      history.replace({ pathname: dashboardURLPath, search: `?${getEncodedURI(params)}` });
    }
    return;
  }

  const loggedInUser = JSON.parse(getDataFromLocalStorage("loggedInUser"));
  if (loggedInUser.data.ou?.name === "K4Mobility") {
    dispatch(fetchIsPrivateOu());
    delete params.filterApplied;
    delete params.internetStatus;
    history.replace({ pathname: dashboardURLPath, search: `?${url_params}${getEncodedURI(params)}` });
  } else {
    dispatch(fetchIsPrivateOu());
    history.replace({ pathname: dashboardURLPath, search: `?${getEncodedURI(params)}` });
  }
};
